import React, { Suspense} from 'react';
import { Text, Billboard } from '@react-three/drei';

const sectionLabels = ["Receiving", "Fulfillment", "Shipping"];
const sectionColors = ["cyan", "yellow", "pink"]; 

const FrontSection = ({ xco, zco, width, floorLength }) => {
    const sectionWidth = width / sectionLabels.length;
    const boxDepth = 15;
    const boxHeight = 0.5;
    const startX = xco - width / 2;
    const boxZ = zco + floorLength / 2 + boxDepth / 2;
    return (
        <>
            {sectionLabels.map((label, index) => {
                const labelX = startX + sectionWidth * index + sectionWidth / 2;
                const color = sectionColors[index];

                return (
                    <group key={label} position={[labelX, boxHeight / 2, boxZ]}>
                        <mesh>
                            <boxGeometry args={[sectionWidth - 1, boxHeight, boxDepth]} />
                            <meshStandardMaterial color={color} />
                        </mesh>
                        <Suspense fallback={null}>
                            <Billboard position={[0, 5, 0]} follow={true} lockX={false} lockY={false} lockZ={false}>
                                <Text
                                    fontSize={5}
                                    color="black"
                                    anchorX="center"
                                    anchorY="middle"
                                    outlineWidth={0.4}
                                    outlineColor="white"
                                >
                                    {label}
                                </Text>
                            </Billboard>
                        </Suspense>
                    </group>
                );
            })}
        </>
    );
};

export default FrontSection;
